<span translate [translateParams]="context.data.interpolateParams ?? {}">{{ context.data.messageKey }}</span>

<div class="flex justify-between margin-top-xxs">
  <a tuiLink ion-id="btn-open-link" class="open-link" [routerLink]="context.data.link"
    ><span translate>GENERAL.OPEN_LINK</span></a
  >
  <button tuiLink ion-id="btn-copy-link" class="cursor-pointer" (click)="copyLink()">
    <span translate>GENERAL.COPY_LINK</span>
  </button>
</div>
